import "./SmallComponent.css";
const Health = () => {
  return (
    <div>
      <h3>This is Health component</h3>
    </div>
  );
};

export default Health;
